export const APP_VERSION = '3.10.0';
